import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

/**
 * La hoja con la banda "XLS" y la flecha de subir: el `FileExcelOutlined` de antd trae una X,
 * que no se reconoce como Excel. Va en `currentColor`, así toma el color del botón. Las letras
 * van en blanco salvo que se defina `--excel-icon-letras`: en un botón primario la banda queda
 * blanca y las letras tienen que tomar el color del botón.
 */
export const ExcelIconSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M13 21.5H6.5C6.22 21.5 6 21.28 6 21V3C6 2.72 6.22 2.5 6.5 2.5H15L20 7.5V14"
      stroke="currentColor"
      strokeWidth="1.1"
      strokeLinejoin="round"
    />
    <path
      d="M15 2.5V7.5H20"
      stroke="currentColor"
      strokeWidth="1.1"
      strokeLinejoin="round"
    />
    <rect
      x="2"
      y="9"
      width="17"
      height="7"
      rx="1"
      fill="currentColor"
    />
    <text
      x="10.5"
      y="14.4"
      textAnchor="middle"
      fontFamily="Arial, Helvetica, sans-serif"
      fontWeight="700"
      fontSize="5.2"
      fill="var(--excel-icon-letras, #ffffff)"
    >
      XLS
    </text>
    <path
      d="M18 23V17.5M15.5 20L18 17.5L20.5 20"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ExcelIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ExcelIconSvg} {...props} />
);
